import { render, staticRenderFns } from "./RouteOptimizeEndpointEditor.vue?vue&type=template&id=a487cade&scoped=true"
import script from "./RouteOptimizeEndpointEditor.vue?vue&type=script&lang=js"
export * from "./RouteOptimizeEndpointEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a487cade",
  null
  
)

export default component.exports